import { Checkbox, ImageFallback, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { useCallback } from 'react';

import { CustomItemTagObject } from '../../../../../../../../store/ProducManagement/types';
import { ItemTag } from '../../../../ItemTag';

interface ProductItemProps {
  columns: number;
  rows?: number;
  label: string;
  value?: unknown;
  isLoading?: boolean;
  onSelect?: (value: string) => void;
  selectedItems?: string[];
  productId?: string;
  managerImage: string;
}

export const ProductItem: React.FC<ProductItemProps> = ({
  columns,
  rows = 1,
  label,
  value,
  onSelect,
  selectedItems,
  productId,
  managerImage,
}) => {
  const flex = 1 / columns;

  const handleSelect = useCallback(
    (selectedValue: string) => {
      onSelect?.(selectedValue);
    },
    [onSelect]
  );

  const isSelected = selectedItems?.includes(productId || '') || false;

  const renderItem = useCallback(
    (itemLabel: string, itemValue: unknown) => {
      if (itemLabel === 'Gestor' || itemLabel === 'Emissor') {
        return (
          <HStack minHeight="100%" flex={1 / 3} space={Spacing['inline.nano']}>
            <Checkbox
              optionPadding={{ bottom: 0, right: 0 }}
              options={[{ label: '', value: productId || '' }]}
              onChange={handleSelect}
              testId={`checkbox-${productId}`}
              selectedValues={isSelected ? [productId || ''] : []}
            />
            <ImageFallback
              src={managerImage}
              alt="logo"
              width="54px"
              height="48px"
              testID="product-img"
              resizeMode="cover"
              borderRadius={BoxRadius.sm}
              resizeMethod="scale"
            />
          </HStack>
        );
      }

      if (itemLabel === 'Bloqueios') {
        return (
          <>
            <Text variant="semibold" color={Color['neutral.black']}>
              {itemLabel}
            </Text>
            <ItemTag data={(itemValue as unknown as CustomItemTagObject[]) || []} />
          </>
        );
      }

      return (
        <>
          <Text variant="semibold" color={Color['neutral.black']}>
            {itemLabel}
          </Text>
          <Text variant="regular" color={Color['neutral.black']} numberOfLines={rows}>
            {String(itemValue) || '-'}
          </Text>
        </>
      );
    },
    [productId, handleSelect, isSelected, rows]
  );

  return (
    <Box flex={flex} py={Spacing['inline.xxxs']} px={Spacing['inline.xxs']} justifyContent="center">
      {renderItem(label, value || '')}
    </Box>
  );
};

export default React.memo(ProductItem);
